import React from "react";



export default function PrintWashRow({job, index}){
    const pickCustomer = (job) =>{
        return job.customer2 ? job.customer2 : job.customer
    }
    return(
        <div>
            <tr>
                <td data-testid={"vehicle-reg"+index}>{job.vehicle.registration}</td>
                <td data-testid={"vehicle-make"+index}>{job.vehicle.make}</td>
                <td data-testid={"vehicle-model"+index}>{job.vehicle.model}</td>
                <td data-testid={"customer"+index}>{pickCustomer(job)}</td>
                <td data-testid={"vehicle-key"+index}>{job.vehicle.key}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </div>
    )





}